// Client-side CSV helpers: RFC-4180-ish cell escaping, and a browser download
// for a finished CSV string.

export type CsvCell = string | number | boolean | null | undefined;

// Escapes a single cell: wraps in double quotes when it contains a comma,
// quote, or newline, and doubles any embedded quotes.
export function escapeCsvCell(value: CsvCell): string {
  if (value === null || value === undefined) return "";
  const str = String(value);
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

// Triggers a client-side download of `csv` as `filename`. No-op outside a DOM
// (so it never throws under SSR/tests).
export function downloadCSV(csv: string, filename: string): void {
  if (typeof document === "undefined") return;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
